<template>
    <section id="beliefs" class="valign-wrapper">
        <div class="row container">
            <!-- <div class="title center">Our Beliefs</div> -->
            <div class="title center"><img src="/assets/images/beliefs.png"></div>
            <div class="col s12 m12 l12 xl10 offset-xl1">
                <ul class="collapsible">
                    <li v-for="(belief, index) in beliefs" :key="index">
                        <div class="collapsible-header" v-on:click="openClose(index)">{{ belief.title }}
                            <i class="material-icons" v-if="!belief.open">keyboard_arrow_down</i>
                            <i class="material-icons" v-else>keyboard_arrow_up</i>
                        </div>
                        <div class="collapsible-body"><span v-html="belief.description"></span></div>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
    import M from 'materialize-css'

    export default {
        name: 'OurBeliefs',
        data: function() {
            return {
                openBelief: -1,
                beliefs: [{
                    title: "The Bible",
                    description: "We believe that the Bible is the inspired and only infallible and authoritative Word of God (2 Timothy 3:16).",
                    open: false
                },{
                    title: "The Father",
                    description: "We believe that there is one God, eternally existent in three persons: God the Father, God the Son, and God the Holy Spirit (Deuteronomy 6:4; Matthew 28:19).",
                    open: false
                },{
                    title: "The Son",
                    description: "We believe in the deity of our Lord Jesus Christ, in His virgin birth, in His sinless life, in His miracles, in His vicarious and atoning death, in His bodily resurrection, in His ascension to the right hand of the Father, in His personal future return to this earth in power and glory to rule a thousand years (John 1:1).",
                    open: false
                },{
                    title: "The Holy Spirit",
                    description: "We believe that the Holy Spirit dwells in us and enables us to live holy lives (Galations 5:16-25). We believe that the baptism in the Holy Spirit is given to believers who ask for it (Acts 2:4).",
                    open: false
                },{
                    title: "Salvation",
                    description: "We believe that the only means of being cleansed from sin is through repentance and faith in the precious blood of Christ (John 14:6), and that regeneration by the Holy Spirit is essential for personal salvation (Titus 3:5).",
                    open: false
                },{
                    title: "Baptism",
                    description: "We believe in water baptism through immersion (Matthew 28:19).",
                    open: false
                },{
                    title: "Healing",
                    description: "We believe that the redemptive work of Christ on the cross provides healing of the human body in answer to believing prayer (1 Peter 2:24).",
                    open: false
                },{
                    title: "Rapture",
                    description: "We believe in the blessed hope &ndash; the rapture of the Church at Christ's second coming (Titus 2:13).",
                    open: false
                },{
                    title: "Resurrection",
                    description: "We believe in the resurrection of both the saved and the lost, the one to everlasting life and the other to everlasting damnation (Revelations 20:11-15).",
                    open: false
                }]
            }
        },
        mounted: function() { 
            var elems = document.querySelectorAll('.collapsible');
            M.Collapsible.init(elems, {});
        },
        methods: {
            openClose: function(pIndex) {
                for (var i = 0; i < this.beliefs.length; i++) {
                    this.beliefs[i].open = false;
                }

                if (this.openBelief == -1 || this.openBelief != pIndex) {
                    this.beliefs[pIndex].open = true;
                    this.openBelief = pIndex;
                }
            }
        }
    }
</script>

<style scoped>
    section {
        padding: 8.5rem 0rem;
        background: url("/assets/images/beliefs2.jpg");
        background-size: cover;
        /* min-height: 800px; */
        background-position: 50% 22%;
    }

    .title {
        color: #ffffff;
        font-weight: normal;
        font-size: 2.5rem;
        margin-bottom: 1rem;
        letter-spacing: .06rem;
    }

    .title img {
        width: 100%;
        height: auto;
        max-width: 750px;
    }

    ul {
        border: none;
        box-shadow: none;
    }

    ul li .collapsible-header {
        position: relative;
        background: transparent;
        font-family: NewhouseDTCond-ExtBold;
        font-size: 1.75rem;
    }

    ul li .collapsible-header i {
        position: absolute;
        right: 5px;
    }

    ul li {
        color: #ffffff;
    }

    ul li .collapsible-body {
        font-size: 1.25rem;
    }
</style>